import { BookOpen } from 'lucide-react';
import {
  translateAcquistionMethodEnum,
  translateContentFormatEnum,
  translateContentTypeEnum,
  translateExecutionFormatEnum
} from '../../../helper/tasksEnum';
import './ContributionsInvestment.scss';

const FORMAT_BADGE = {
  'VIDEO': { label: 'Vídeo', color: 'rgba(99,102,241,0.2)', border: 'rgba(99,102,241,0.5)', text: '#a5b4fc' },
  'AUDIO': { label: 'Áudio', color: 'rgba(16,185,129,0.2)', border: 'rgba(16,185,129,0.5)', text: '#6ee7b7' },
  'TEXT': { label: 'Texto', color: 'rgba(245,158,11,0.2)', border: 'rgba(245,158,11,0.5)', text: '#fcd34d' },
};

const Badge = ({ value }) => {
  const style = FORMAT_BADGE[value] ?? {
    color: 'rgba(255,255,255,0.07)',
    border: 'rgba(255,255,255,0.15)',
    text: 'rgba(255,255,255,0.6)'
  };
  return (
    <span className="ci-badge" style={{
      background: style.color,
      borderColor: style.border,
      color: style.text
    }}>
      {translateContentTypeEnum(value) ?? value ?? '—'}
    </span>
  );
};

const ContributionsInvestment = ({ investmentDetails }) => {
  const tasks = Array.isArray(investmentDetails?.tasks?.items)
    ? investmentDetails.tasks.items
    : [];

  return (
    <div className="ci-root">
      <div className="ci-header">
        <BookOpen size={16} className="ci-header-icon" />
        <span className="ci-header-count">{tasks.length} aportes registrados</span>
      </div>

      {tasks.length === 0 ? (
        <div className="ci-empty">
          <BookOpen size={36} className="ci-empty-icon" />
          <p>Nenhum aporte encontrado</p>
        </div>
      ) : (
        <div className="ci-table-wrapper">
          <table className="ci-table">
            <thead>
              <tr>
                <th>Investimento</th>
                <th>Nome do aporte</th>
                <th>Formato</th>
                <th>Meio</th>
                <th>Modalidade</th>
                <th>Custo</th>
              </tr>
            </thead>
            <tbody>
              {tasks.map((task) => (
                <tr key={task?.id}>
                  <td>
                    {task?.topic?.symbol && (
                      <span className="ci-symbol">{task.topic.symbol}</span>
                    )}
                  </td>
                  <td className="ci-title">{task?.title ?? '—'}</td>
                  <td><Badge value={task?.contentType} /></td>
                  <td className="ci-text">{translateContentFormatEnum(task?.contentFormat) ?? '—'}</td>
                  <td className="ci-text">{translateExecutionFormatEnum(task?.taskFormat) ?? '—'}</td>
                  <td>
                    <span className={`ci-cost${task?.contentAcquisition === 'FREE' ? ' ci-cost--free' : ''}`}>
                      {translateAcquistionMethodEnum(task?.contentAcquisition) ?? '—'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ContributionsInvestment;
